<template>
  <div id="bind-main" class="bind-screen">
    <div class="code-img">
      <div class="bind-left">
        <div class="bind-title">绑定微信&nbsp;&nbsp;轻松下单</div>
        <div class="bind-row">
          <div class="bind-col">
            <img class="bind-aimg" src="../assets/imgs/ba1.png" width="70">
            <div class="bind-atxt">用微信小程序线下接单</div>
          </div>
          <div class="bind-col">
            <img class="bind-aimg" src="../assets/imgs/ba2.png" width="70">
            <div class="bind-atxt">一键分享商品给顾客</div>
          </div>
        </div>
        <div class="bind-row">
          <div class="bind-col">
            <img class="bind-aimg" src="../assets/imgs/ba3.png" width="70">
            <div class="bind-atxt">顾客下单传资料进度随时查</div>
          </div>
          <div class="bind-col">
            <img class="bind-aimg" src="../assets/imgs/ba4.png" width="70">
            <div class="bind-atxt">签证状态微信同步推送</div>
          </div>
        </div>
      </div>
      <div class="bind-right">
        <div class="bind-code-wrap">
          <img :src="bindQrcode" class="bind-code">
        </div>
        <div class="bind-steps">
          <p><span>1</span>打开微信扫一扫</p>
          <p><span>2</span>点击”允许“申请操作</p>
          <p><span>3</span>完成绑定</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import {
  SAVE_MP_WATCH,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';

import utils from '../libs/utils';
import Http from '../libs/http';
import User from '../libs/user';
import WxUtils from '../libs/wx-utils';

export default{
  data() {
    return {
      itv: '',
      redirectUrl: '',
      bindQrcode: '',
    };
  },
  created() {
    this.checkBindWeChat();
    this.redirectUrl = this.$route.query.redirectUrl ? decodeURIComponent(this.$route.query.redirectUrl) : '/';
    this.initQrcode();
  },
  watch: {
    $route(val) {
      this.redirectUrl = val.query.redirectUrl ? decodeURIComponent(val.query.redirectUrl) : '/';
    },
  },
  methods: {
    ...mapMutations('followOA/', [
      SAVE_MP_WATCH,
    ]),
    initQrcode() {
      WxUtils.getBindPageQRCode(User.peer_account_id).then((url) => {
        this.bindQrcode = url;
      });
    },

    checkBindWeChat() {
    // 检测是否绑定微信
      this.itv = setInterval(() => {
        if (User.isLogin()) {
          Http.post('/peer_account_query', {}).then((data) => {
            if (data.mp_watch) {
              this.SAVE_MP_WATCH({ mp_watch: data.mp_watch });
            }
            if (data.wxinfo && data.wxinfo.openid) {
              utils.extend(User, data);

              utils.msg.success('绑定微信成功');
              clearInterval(this.itv);

              setTimeout(() => {
                this.$router.replace({ path: this.redirectUrl });
              }, 1500);
            }
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      }, 1500);
    },
  },
  beforeDestroy() {
    if (this.itv) {
      clearInterval(this.itv);
    }
  },
};
</script>

<style lang="less" scoped>
  .bind-screen{
    .bind-right{
      padding-left: 0px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      display: flex;
      .bind-code-wrap{
        z-index: 1;
        background-color: #ffffff;
        position: relative;
        .wechat-logo{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .bind-steps{
        width: 300px;
        height: 136px;
        margin-left: 0px;
        transform: translateY(-20px);
        border-radius: 6px;
        padding: 40px 10px 20px 30px;
        p{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          padding-left: 0;
          &+p{
            margin-top: 12px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Bind.vue